import { FormCard, FormItem, Input } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { NAMESPACE } from 'locale'
import { generalConstants } from 'locale/general'
import { useTranslation } from 'react-i18next'

export const CustomIdFormCard = () => {
  const { t } = useTranslation(NAMESPACE.GENERAL)

  return (
    <FormCard
      title={t(generalConstants.CUSTOM_ID)}
      subtitle={t(generalConstants.CUSTOM_ID_DESC)}
    >
      <FormItem
        label={<Text>{t(generalConstants.CUSTOM_ID)}</Text>}
        name="customId"
      >
        <Input />
      </FormItem>
    </FormCard>
  )
}
